import { Outlet, Route, Routes } from "react-router-dom";
import {
  IvMuiThemeProvider,
  PageLayout,
  Redirect,
} from "@consumerig/iv-components";
import { CssBaseline } from "@mui/material";
import { PUBLIC_URL } from "../helpers/constants";
import { FileUploadDataProvider } from "../feature/FileUpload/FileUploadDataProvider";
import { MapRadiusDataProvider } from "../feature/MapRadius/MapRadiusDataProvider";
import { FSAMapDataProvider } from "../feature/FSAMap/FSAMapDataProvider";
import { MergeFilesDataProvider } from "../feature/MergeFiles/MergeFilesDataProvider";
import { ExtractAudienceDataProvider } from "../feature/ExtractAudience/ExtractAudienceDataProvider";
import RunProfileReportFileIdProvider from "../common/RunProfileReportFileIdProvider/RunProfileReportFileIdProvider";
import {
  Dashboard,
  AdSpot,
  CarrierWalkReport,
  FileUploaderContainer,
  FSAMapContainer,
  MapRadiusContainer,
  MergeFilesContainer,
  ExtractAudienceContainer,
  AddNewFile,
  ExtracedAudiencesListView,
  CarrierWalkListView,
  InsightsReportFileSelection,
  FilesListView,
  ReportsListView,
  ProjectsListView,
  NotFound,
  BatchFileUploader,
} from "./index";
import { Suspense } from "react";

function LazyRoute({ children }) {
  return <Suspense fallback={<></>}>{children}</Suspense>;
}

export default function AppRoutes() {
  return (
    <Routes>
      <Route
        path={PUBLIC_URL}
        element={
          <IvMuiThemeProvider>
            <CssBaseline />
            <Outlet />
          </IvMuiThemeProvider>
        }
      >
        <Route
          path=""
          element={
            <LazyRoute>
              <Dashboard />
            </LazyRoute>
          }
        />
        <Route path="fe" element={<Redirect to={"/"} />} />
        <Route
          path="ad_spot"
          element={
            <LazyRoute>
              <AdSpot />
            </LazyRoute>
          }
        />
        <Route
          path="carrier_walk_report"
          element={
            <LazyRoute>
              <CarrierWalkReport />
            </LazyRoute>
          }
        />
        <Route
          path="file_uploader"
          element={
            <LazyRoute>
              <PageLayout>
                <RunProfileReportFileIdProvider>
                  <FileUploadDataProvider>
                    <FileUploaderContainer />
                  </FileUploadDataProvider>
                </RunProfileReportFileIdProvider>
              </PageLayout>
            </LazyRoute>
          }
        />
        <Route
          path="build/upload-files"
          element={
            <LazyRoute>
              <PageLayout>
                <BatchFileUploader />
              </PageLayout>
            </LazyRoute>
          }
        />

        <Route
          path="fsa_map"
          element={
            <LazyRoute>
              <RunProfileReportFileIdProvider>
                <FSAMapDataProvider>
                  <FSAMapContainer />
                </FSAMapDataProvider>
              </RunProfileReportFileIdProvider>
            </LazyRoute>
          }
        />
        <Route
          path="map_radius"
          element={
            <LazyRoute>
              <PageLayout>
                <RunProfileReportFileIdProvider>
                  <MapRadiusDataProvider>
                    <MapRadiusContainer />
                  </MapRadiusDataProvider>
                </RunProfileReportFileIdProvider>
              </PageLayout>
            </LazyRoute>
          }
        />
        <Route
          path="merge_files"
          element={
            <LazyRoute>
              <PageLayout>
                <RunProfileReportFileIdProvider>
                  <MergeFilesDataProvider>
                    <MergeFilesContainer />
                  </MergeFilesDataProvider>
                </RunProfileReportFileIdProvider>
              </PageLayout>
            </LazyRoute>
          }
        />
        <Route
          path="extract_audience"
          element={
            <LazyRoute>
              <PageLayout>
                <ExtractAudienceDataProvider>
                  <ExtractAudienceContainer />
                </ExtractAudienceDataProvider>
              </PageLayout>
            </LazyRoute>
          }
        />
        <Route
          path="add_new_file"
          element={
            <LazyRoute>
              <PageLayout>
                <AddNewFile />
              </PageLayout>
            </LazyRoute>
          }
        />
        <Route
          path="extracted_audiences"
          element={
            <LazyRoute>
              <ExtracedAudiencesListView />
            </LazyRoute>
          }
        />
        <Route
          path="carrier_walk_list_view"
          element={
            <LazyRoute>
              <CarrierWalkListView />
            </LazyRoute>
          }
        />
        <Route
          path="report_new"
          element={
            <LazyRoute>
              <InsightsReportFileSelection />
            </LazyRoute>
          }
        />
        <Route
          path="files"
          element={
            <LazyRoute>
              <FilesListView />
            </LazyRoute>
          }
        />
        <Route
          path="reports"
          element={
            <LazyRoute>
              <ReportsListView />
            </LazyRoute>
          }
        />
        <Route
          path="projects"
          element={
            <LazyRoute>
              <ProjectsListView />
            </LazyRoute>
          }
        />
        <Route
          path="*"
          element={
            <LazyRoute>
              <PageLayout>
                <NotFound />
              </PageLayout>
            </LazyRoute>
          }
        />
      </Route>
    </Routes>
  );
}
